import { FC, useState} from 'react';
import "./DateComponent.css";
import SimpleCalendar from "../../Shared/Calendar/SimpleCalendar";
import { ILicenseViewModule } from '../../../common/api_interfaces/license/ILicenseView';


interface IDateComponent {
    errorMessage: string | undefined;
    module: ILicenseViewModule;
    startDateDefault?: Date;
}


const DateComponent: FC<IDateComponent> = ({ errorMessage, module, startDateDefault }) => {
    const [startDate, setStartDate] = useState<Date | undefined>(startDateDefault);
    const [endDate, setEndDate] = useState<Date | undefined>(undefined);
    const [isDateEndBad, setIsDateEndBad] = useState<boolean>(false);
    const messageBlock = "Дата некорректна";
    const baseZIndex = 10000;

    function onChangeStartDate(event: any) {
        if (module) {
            module.dateFrom = event.toString();
        }

        validateDates(event, endDate);
        setStartDate(event);
    }
    function onChangeEndDate(event: any) {
        if (module) {
            module.dateTo = event.toString();
        }

        validateDates(startDate, event);
        setEndDate(event);
    }

    function validateDates (_dateFrom: any, _dateTo: any) {
        if (!_dateFrom && !_dateTo) {
            setIsDateEndBad(true);
        }
        else if (_dateFrom < _dateTo) {
            setIsDateEndBad(false);
        }
        else if (_dateFrom >= _dateTo) {
            setIsDateEndBad(true);
        }
    }

    function checkClickOnButtonReq() {
        return (errorMessage ? 
            (!startDate || !endDate ? 
                <div className='date-incorrect-text'>
                    {errorMessage}
                </div> 
                : checkEndDate()
                ) 
            : checkEndDate()
        );
    }

    function checkEndDate() {
        return (
            isDateEndBad ? 
            <div className='date-incorrect-text'>
                {messageBlock}
            </div> 
            : null
        );
    }

    return (
            <div className='date-block'>
                <div className='date-frame'>
                    <div>
                        {"с"}
                    </div>
                    <SimpleCalendar
                        baseZIndex={baseZIndex}
                        onChange={onChangeStartDate}
                        date={startDate}
                    />
                    <div>
                        {"по"}
                    </div>
                    <SimpleCalendar
                        baseZIndex={baseZIndex}
                        onChange={onChangeEndDate}
                        date={endDate}
                    />
                </div>
                {checkClickOnButtonReq()}
            </div>
    );
}


export default DateComponent;